if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[{"alias":"OP_WEB_COMMON_SERVICE","name":"OP_WEB_COMMON_SERVICE","entry":"[window.OP_WEB_COMMON_SERVICEUrl]/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(4(06|4|46|74|79)|121|249|65|670|8|998)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}